/*********** Footer Script START**************/

if ($(window).width() < 767){
 $('footer .footer-block__heading').each(function(){
    $(this).click(function(){
        $(this).siblings('.footer-block__details-content').slideToggle();
        $(this).toggleClass('active');
    })
 })
}

/*********** Footer Script END**************/
$( document ).ready(function() {

  
  var checkedkVal = $('.option_field:checked').val();
  if(checkedkVal == "One Size with Customization"){
    $('.customExtraFields').removeClass('hide');
  }
  $('body').on('click', '.option_field', function(){
    var textVal = $(this).val();
    // alert(textVal);
    if(textVal == "One Size with Customization"){
      $('.customExtraFields').removeClass('hide');
    }else{
      $('.customExtraFields').addClass('hide');
    }
  });


  $('body').on('click', '.wishlistBtn button', function(){
    $(this).parent().parent().find('cart-remove-button .button').trigger('click');
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const readMoreButton = document.querySelector('.read-more-button');
  const descriptionLess = document.querySelector('.product__description .readLessDesc');
  const descriptionMore = document.querySelector('.product__description .readMoreDesc');

  readMoreButton.addEventListener('click', () => {
    if (descriptionMore.classList.contains('hide')) {
      descriptionLess.classList.add('hide');
      descriptionMore.classList.remove('hide');
      readMoreButton.textContent = 'Read Less';
    } else {
      descriptionMore.classList.add('hide');
      descriptionLess.classList.remove('hide');
      readMoreButton.textContent = 'Read More';
    }
  });
});

